import { UserByTokenApiDTO } from "../dtos";
import { UserByToken } from "@/models/user/user-by-token.model";

export const mapUserByTokenDtoToUserByToken = (userDTO: UserByTokenApiDTO["data"]): UserByToken => {
  return {
    email: userDTO.email,
  };
};
